const SelectIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.67 2H16.34C19.73 2 22 4.38 22 7.92V16.091C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.091V7.92C2 4.38 4.28 2 7.67 2ZM11.4299 14.9901L16.1799 10.2401C16.5199 9.90012 16.5199 9.35012 16.1799 9.00012C15.8399 8.66012 15.2799 8.66012 14.9399 9.00012L10.8099 13.1301L9.05994 11.3801C8.71994 11.0401 8.15994 11.0401 7.81994 11.3801C7.47994 11.7201 7.47994 12.2701 7.81994 12.6201L10.1999 14.9901C10.3699 15.1601 10.5899 15.2401 10.8099 15.2401C11.0399 15.2401 11.2599 15.1601 11.4299 14.9901Z"
        fill="#57585C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.34 2.83333H7.67C6.17732 2.83333 4.98568 3.3527 4.16556 4.20893C3.34245 5.06828 2.83333 6.33064 2.83333 7.92V16.091C2.83333 17.6742 3.34204 18.9338 4.16518 19.792C4.98541 20.6473 6.17728 21.1667 7.67 21.1667H16.34C17.8326 21.1667 19.0215 20.6474 19.8391 19.7928C20.6598 18.9349 21.1667 17.6752 21.1667 16.091V7.92C21.1667 6.32963 20.6594 5.06716 19.8387 4.20817C19.0212 3.35256 17.8325 2.83333 16.34 2.83333ZM16.34 2H7.67C4.28 2 2 4.38 2 7.92V16.091C2 19.62 4.28 22 7.67 22H16.34C19.73 22 22 19.62 22 16.091V7.92C22 4.38 19.73 2 16.34 2Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default SelectIcon;
